import { Button } from "antd";
import React from "react";

const ErrorPopup = ({ visible, errorDetails, onClose }) => {
  if (!visible) return null;

  return (
    <div className="error-popup-overlay" onClick={onClose}>
      <div
        className="error-popup-container"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="error-popup-header">
          <div className="error-popup-title">
            <span className="error-icon">⚠️</span>
            <span>Validation Errors: Min/Max Mismatches Detected</span>
          </div>
          <Button
            type="text"
            size="small"
            onClick={onClose}
            className="error-popup-close"
          >
            ✕
          </Button>
        </div>

        {/* Content */}
        <div className="error-popup-content">
          {errorDetails && errorDetails.errors ? (
            <>
              {/* Summary Section */}
              <div className="error-summary">
                <div className="error-summary-box">
                  <p className="error-count">
                    {errorDetails.totalErrors} validation error
                    {errorDetails.totalErrors > 1 ? "s" : ""} found
                  </p>
                  <p className="error-context">
                    <strong>Job Number:</strong> {errorDetails.jobNumber} |{" "}
                    <strong>Level:</strong> {errorDetails.calculationLevel}
                  </p>
                </div>
              </div>

              {/* Error List */}
              <div className="error-list-container">
                <p className="error-description">
                  The following parameters have Min values that are greater than
                  or equal to Max values:
                </p>

                <div className="error-list">
                  {errorDetails.errors.map((error, index) => (
                    <div key={index} className="error-item">
                      <div className="error-item-header">
                        <span className="error-parameter">
                          {error.parameterFull}
                        </span>
                        <span className="error-pass-group">
                          {error.passGroup}
                        </span>
                      </div>

                      <div className="error-values">
                        <div className="error-value-item">
                          <span className="error-label">Min:</span>
                          <span className="error-value min-value">
                            {error.minValue}
                          </span>
                        </div>
                        <span className="error-arrow">→</span>
                        <div className="error-value-item">
                          <span className="error-label">Max:</span>
                          <span className="error-value max-value">
                            {error.maxValue}
                          </span>
                        </div>
                      </div>

                      <div className="error-message">
                        Min value should be less than Max value
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </>
          ) : (
            <div className="error-fallback">
              <p className="error-fallback-title">
                Min value cannot be greater than or equal to Max value
              </p>
              <p className="error-fallback-message">
                Please check your input values and ensure Min values are less
                than Max values.
              </p>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="error-popup-footer">
          <div className="error-tip">
            <strong>💡 Tip:</strong> Please correct the Min/Max values to ensure
            Min is less than Max.
          </div>
          <Button
            type="primary"
            danger
            onClick={onClose}
            className="error-popup-ok-btn"
          >
            OK
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorPopup;
